import { I, Mark, Strong } from '@expo/html-elements'
import type { ReactElement, ReactNode } from 'react'
import { useIntl, type IntlShape } from 'react-intl'
import { Text } from 'react-native'

type TFormatMessage = IntlShape['formatMessage']
export type TMessageKey = Exclude<Parameters<TFormatMessage>[0]['id'], undefined>
type TMessageValues = Parameters<TFormatMessage>[1]

export const getKey = (chunks: ReactNode[], tag: string) => {
  if (chunks.length > 0 && typeof chunks[0] === 'string') {
    return `${chunks[0]?.split('').length}-${tag}`
  }
  return tag
}

export const htmlTagsMap: Partial<Record<string, (chunks: ReactNode[]) => ReactElement | string>> = {
  strong: (chunks) => <Strong key={getKey(chunks, 'str')}>{chunks}</Strong>,
  i: (chunks) => <I key={getKey(chunks, 'i')}>{chunks}</I>,
  mark: (chunks) => <Mark key={getKey(chunks, 'mark')}>{chunks}</Mark>,
  br: () => '\n',
  u: (chunks) => (
    <Text key={getKey(chunks, 'u')} className="underline">
      {chunks}
    </Text>
  ),
  p: (chunks) => (
    <Text className="block py-1" key={getKey(chunks, 'p')}>
      {chunks}
    </Text>
  ),
}

type TFnTranslate = {
  (id: TMessageKey, values?: Record<string, string | number>): string

  <MessageValues extends TMessageValues | undefined>(
    id: TMessageKey,
    values?: MessageValues,
  ): ReturnType<TFormatMessage>
}

export const useTranslate = () => {
  const intl = useIntl()

  // any type is necessary to match all implementations of TFnTranslate
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  const t: TFnTranslate = (id: TMessageKey, values?: any) => {
    return intl.formatMessage({ id }, { ...values, ...htmlTagsMap })
  }

  return { t }
}

export type TT = ReturnType<typeof useTranslate>['t']
